export function hexToRgb(hex) {
  // Convert hex color to RGB color string
  const bigint = Number.parseInt(hex.substring(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `${r} ${g} ${b}`;
}

export default hexToRgb;
